import React, { Component } from 'react';
import { Form, Input, Modal, Button, Icon, Header, Message } from 'semantic-ui-react';
import ToastUtilities from './ToastUtilities';
import PhoneInput from 'react-phone-number-input';
import AuthService from '../services/Auth';
let authService = new AuthService();

const INITIAL_STATE = {
    email: '',
    name: '',
    phone: '',
    errors: [],
    loading: false
};

export default class Register extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({ ...INITIAL_STATE });
        }
    }

    handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

    handlePhoneNumberChange = (value) => this.setState({ phone: value });

    handleSubmit = (e) => {
        this.setState({ loading: true });
        e.preventDefault();
        const { email, name, phone } = this.state;
        authService.register(email, name, phone)
            .then((response) => {
                this.setState({ loading: false });
                if (!response.isError) {
                    ToastUtilities.success('Check your email for your credentials.', 2000);
                    this.props.handleClose();
                } else {
                    const errors = Object.values(response.errorContent).flat();
                    this.setState({ errors: errors });
                }
            });
    }

    render() {
        const { email, name, phone, errors, loading } = this.state;
        const invalid = email === '' || name === '' || phone === '' || loading;

        return (
            <Modal open={this.props.modalOpen}
                closeOnEscape={true}
                closeOnDimmerClick={false}
                size='small'
                closeIcon
                onClose={this.props.handleClose}
            >
                <Header icon='user' content='Register' />
                <Modal.Content>
                    <Form onSubmit={this.handleSubmit} error>
                        <Form.Field>
                            <label>Email:</label>
                            <Input
                                name='email'
                                placeholder='Email'
                                value={email}
                                onChange={this.handleChange}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Full Name:</label>
                            <Input
                                name='name'
                                placeholder='Full Name'
                                value={name}
                                onChange={this.handleChange}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Phone:</label>
                            <PhoneInput
                                placeholder='Phone'
                                value={phone}
                                onChange={value => this.handlePhoneNumberChange(value)}
                                name='phone'
                                country='US'
                                international={false}
                                showCountrySelect={false}
                                limitMaxLength={true}
                            />
                        </Form.Field>
                        {errors.length > 0 && (
                            <Message
                                error
                                header='Registration info is not valid.'
                                list={errors}
                            />
                        )}
                        <Button color='green' type='submit' disabled={invalid} className='auth-button' loading={loading}>
                            <Icon name='user' /> Register
                        </Button>
                        <Button basic onClick={this.props.handleClose} className='auth-button' loading={loading}>
                            <Icon name='remove' /> Close
                        </Button>
                    </Form>
                </Modal.Content>
            </Modal>

        );
    }
}